// extracted by mini-css-extract-plugin
module.exports = {"dialog":"_1wmWPWg_rClPJFcvJKL7O1","sub-title":"_2lPot4bZyKkmd4_riTWMoc","block-outlets":"_9R2nDk79HucrCsJ6ITMRZ","failed-all-outlets":"_3gNnIrYsxUGihxT4FM1hLD"};